import { SharedScreenName } from '../../config/FlowTypes';
import { ActionType } from '../ActionTypes';
import { StoreAction, StoreStateInternal } from '../Store';
import { Page, PageStackState } from './PageStackState';

export type PageStackAction =
  | {
      type: ActionType.SET_PAGE;
      page: Page;
      resetHistory?: boolean;
    }
  | {
      type: ActionType.SET_PAGE_STACK;
      pageStack: PageStackState;
    }
  | {
      type: ActionType.DECREMENT_PAGE;
    };

export function pageStackReducer(state: PageStackState, action: StoreAction): PageStackState {
  switch (action.type) {
    case ActionType.SET_PAGE: {
      const newStack = action.resetHistory ? [action.page] : [...state, action.page];
      return newStack;
    }

    case ActionType.SET_PAGE_STACK: {
      return action.pageStack;
    }

    case ActionType.DECREMENT_PAGE: {
      const newStack = state.slice(0, -1);
      return newStack;
    }

    case ActionType.LOGIN_USER_SUCCESS: {
      // CAUTION token flow is currently only designed for Nerva, skipping directly to the Gender screen
      // is not guaranteed to work for other products
      if (action.method === 'token') {
        return [...state, SharedScreenName.Gender];
      }
    }

    default:
      return state;
  }
}

export const PageStackSelector = {
  pageStack(state: StoreStateInternal): PageStackState {
    return state.pageStack;
  },

  currentPage(state: StoreStateInternal): Page {
    return state.pageStack[state.pageStack.length - 1];
  },
};
